import { Button, makeStyles } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { useEffect, useMemo, useState } from 'react';
import Lottie from "react-lottie-player/dist/LottiePlayerLight";

import cartData from './cart.json'
import checkData from './check.json'

const useStyles = makeStyles(theme => ({
  button: {
    transition: 'width 0.5s',
    whiteSpace: 'nowrap',
  },
  lottie: {
    top: 0,
    zIndex: 10,
    position: "absolute",
    pointerEvents: "none",
    transition: 'right 0.5s'
  }
}));
const AddToCartButton = ({
  animationData = cartData,
  animationProps = {
    width: 60,
    height: 60,
    rightOffset: 0,
  },
  fabDisabled=false,
  ...props
}) => {
  const classes = useStyles()
  const [finalState, setFinalState] = useState(false);
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '60px',
        overflow: 'hidden',
      }}
    > {
      fabDisabled ? null :
      <Lottie
        rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
        className={classes.lottie}
        style={{
          right: finalState ? `calc(50% - ${animationProps?.width/2}px)` : `${animationProps?.rightOffset}px`,
          ...animationProps
        }}
        play={finalState ? true : false}
        loop={0}
        segments={[[0, 45]]}
        animationData={animationData}
        onComplete={() => {
          props?.onClick()
        }}
        resizeMode="cover"

      />
    }
      <Button
        {...props}

        onClick={(e) => {
          setFinalState(true)
          if (fabDisabled) {
            props?.onClick(e)
          }
        }}
        className={classes.button}
        style={{
          width: finalState ? '60px' : '100%',
          height: '60px',
          opacity: finalState ? 0 : 1
        }}
      >
        {props.children || "Add to Cart"}
      </Button>
    </div>
  )
}

const LabTestAddButton = (props) => {
  return (
    <AddToCartButton
      {...props}
      animationData={checkData}
      animationProps={{
        width: 100,
        height: 100,
        top: -20,
        rightOffset: -20
      }}
    />
  )
}
const DisabledFabButton = (props) => {
  return (
    <AddToCartButton
      {...props}
      fabDisabled={true}
    />
  )
}

export {DisabledFabButton, LabTestAddButton, AddToCartButton }